import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { pathnameToAffiliateContext } from '../lib/affiliateContext';
import { AffiliatePlacement } from './AffiliatePlacement';

export function PageAffiliateStrip() {
  const { pathname } = useLocation();
  const context = useMemo(() => pathnameToAffiliateContext(pathname), [pathname]);

  if (!context) return null;

  return (
    <AffiliatePlacement
      slot="footer"
      className="mt-10 border-t border-black/[0.06] pt-6 opacity-90"
    />
  );
}
